export var EUserType;
(function (EUserType) {
    // MERCHANT = "MERCHANT",
    EUserType["STORE"] = "STORE";
})(EUserType || (EUserType = {}));
